import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../../services/adminService';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import PasswordField from '../../components/PasswordField';

const AdminLogin = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = await loginAdmin(formData);
            login({ email: formData.email, role: 'ADMIN' },
                token);
            toast.success('Admin login successful!');
            navigate('/admin-dashboard');
        } catch (error) {
            toast.error(error.response?.data?.message
                || 'Login failed!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="premium-auth-page">
            <div className="container py-4">
                <div className="premium-auth-card premium-auth-card-user">
                    <div className="premium-auth-header">
                        <div className="premium-auth-badge">🔐</div>
                        <h2 className="premium-auth-title">Admin Login</h2>
                        <p className="premium-auth-subtitle">Secure access for trusted administration</p>
                    </div>
                    <div className="premium-auth-body">
                        <form onSubmit={handleSubmit} className="premium-auth-form">
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Admin email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <PasswordField
                                        label="Password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="Admin password"
                                        required
                                    />
                                    <button
                                        type="submit"
                                        className="btn w-100 text-white fw-bold"
                                        style={{ backgroundColor: '#8B4513' }}
                                        disabled={loading}>
                                        {loading
                                            ? 'Logging in...'
                                            : '🔐 Admin Login'}
                                    </button>
                                </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;